export default __webpack_public_path__ + "resources/icons/d300-6e08.png";